import { IApiMessage, TemplateType } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useMutation, useQuery, useQueryClient } from 'react-query'

export const useToastsQuery = () => {
  const fetchToasts = async () => {
    return await medicareApiClient.asyncGetMessages({
      templateType: TemplateType.Toast
    })
  }

  return useQuery<IApiMessage[] | undefined>('toasts', fetchToasts)
}

export function useMarkToastsRead () {
  const queryClient = useQueryClient()

  const markToastsRead = async (messageIds: string[]) => {
    return await medicareApiClient.asyncMarkMessageRead({
      messageIds
    })
  }

  const optimisticUpdate = async (messageIds: string[]) => {
    // Cancel any outgoing refetches
    await queryClient.cancelQueries({ queryKey: ['toasts'] })

    // Snapshot the previous value
    const previousItems = queryClient.getQueryData(['toasts'])

    // Optimistically update to the new value
    queryClient.setQueryData<IApiMessage[] | undefined>(['toasts'], (old) => {
      return old?.map((item) =>
        messageIds.includes(item.guid) ? { ...item, read: true } : item
      )
    })

    // Return a context object with the snapshotted value
    return { previousItems }
  }

  return useMutation({
    mutationFn: markToastsRead,
    onMutate: optimisticUpdate,
    onError: (_err, _messageIds, context) => {
      // Set back to previous snapshot value
      queryClient.setQueryData(['toasts'], context?.previousItems)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['toasts'] })
    }
  })
}
